import VueLocalStorage from 'vue-ls'
import Vue from "vue";
Vue.use(VueLocalStorage, {
    name: 'ls'
});


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/localstorage.js